<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 0L5.4 24H18.6L21 0H3ZM5.64 2.4H18.36L18 6.276C14.016 7.8 12.42 6.804 11.856 6.372C11.556 6.144 11.124 5.628 10.332 5.268C9.54 4.896 8.46 4.8 7.2 5.184C6.708 5.316 6.324 5.532 6 5.748L5.64 2.4ZM8.832 7.332C9.06 7.332 9.192 7.38 9.324 7.44C9.6 7.56 9.852 7.86 10.404 8.28C11.436 9.072 13.836 10.032 17.712 8.892L16.44 21.6H7.56L6.252 8.472C6.312 8.4 6.492 8.268 6.804 8.052C7.2 7.8 7.692 7.536 7.8 7.5H7.836C8.292 7.368 8.604 7.32 8.832 7.332Z"
      fill="currentColor"
    />
  </svg>
</template>
